function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.20284 40.1274L5.16389 37.7725C3.73697 34.5381 3 31.0418 3 27.5067V11C3 6.22772 7.56775 2.78226 12.1564 4.09331L39.5131 11.9095C40.4798 12.1857 41.425 12.5321 42.3412 12.9459L53.2681 17.8806C54.018 18.2192 54.5 18.9658 54.5 19.7886C54.5 24.624 58.7123 28.3806 63.5162 27.8293L79.5795 25.986C86.0872 25.2392 91 19.7304 91 13.18C91 9.1665 94.4168 6.00246 98.4184 6.31028L105.424 6.84918C106.426 6.92627 107.417 7.1159 108.376 7.41449L111.18 8.28658C119.903 11.0006 125.168 19.8653 123.376 28.8239L123.192 29.7422C122.696 32.2228 122.696 34.7772 123.192 37.2578C124.821 45.4018 118.592 53 110.287 53H70.5224C66.6522 53 62.8269 52.1714 59.3037 50.5699C51.8285 47.1721 43.3574 46.673 35.5349 49.1696L30.1174 50.8985C26.1554 52.163 21.894 52.1357 17.9485 50.8205C12.7009 49.0714 8.43555 45.1882 6.20284 40.1274Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgOffroad4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 56,
    viewBox: "0 0 127 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffroad4);
export default __webpack_public_path__ + "static/media/offroad4.dcc60a01.svg";
export { ForwardRef as ReactComponent };